import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const PERMISSIONS = [
  { key: 'manage_users', label: 'Gestionar usuarios', roles: ['SUPER_ADMIN', 'ADMIN'] },
  { key: 'approve_users', label: 'Aprobar/rechazar usuarios', roles: ['SUPER_ADMIN', 'ADMIN'] },
  { key: 'manage_updates', label: 'Gestionar actualizaciones', roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR'] },
  { key: 'upload_updates', label: 'Cargar actualizaciones', roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR'] },
  { key: 'assign_updates', label: 'Asignar actualizaciones', roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR'] },
  { key: 'view_reports', label: 'Ver reportes', roles: ['SUPER_ADMIN', 'ADMIN'] },
  { key: 'system_config', label: 'Configuración del sistema', roles: ['SUPER_ADMIN'] },
  { key: 'manage_orgs', label: 'Gestionar organizaciones', roles: ['SUPER_ADMIN', 'ADMIN'] },
  { key: 'download_updates', label: 'Descargar actualizaciones', roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR', 'CUSTOMER_USER'] },
  { key: 'view_profile', label: 'Ver perfil propio', roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR', 'CUSTOMER_USER'] },
];

const ROLES = ['SUPER_ADMIN', 'ADMIN', 'OPERATOR', 'CUSTOMER_USER'];
const ROLE_LABELS = { SUPER_ADMIN: 'Super Admin', ADMIN: 'Admin', OPERATOR: 'Operador', CUSTOMER_USER: 'Usuario' };
const ROLE_COLORS = { SUPER_ADMIN: 'text-purple-700', ADMIN: 'text-blue-700', OPERATOR: 'text-cyan-700', CUSTOMER_USER: 'text-gray-600' };

const RolePermissionsPanel = ({ currentUserRole }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <button
        onClick={() => setIsOpen(v => !v)}
        className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center">
            <Icon name="Shield" size={16} color="#7C3AED" />
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-gray-800 font-heading">Matriz de Permisos</p>
            <p className="text-xs text-gray-500 font-caption">Roles y accesos del sistema</p>
          </div>
        </div>
        <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={16} color="#9CA3AF" />
      </button>
      {isOpen && (
        <div className="border-t border-gray-100 overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-4 py-2.5 text-left font-caption font-semibold text-gray-600 min-w-[160px]">Permiso</th>
                {ROLES?.map(role => (
                  <th key={role} className={`px-3 py-2.5 text-center font-caption font-semibold ${ROLE_COLORS?.[role]}`}>
                    {ROLE_LABELS?.[role]}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {PERMISSIONS?.map((perm, idx) => (
                <tr key={perm?.key} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}>
                  <td className="px-4 py-2 text-gray-700 font-caption">{perm?.label}</td>
                  {ROLES?.map(role => (
                    <td key={role} className="px-3 py-2 text-center">
                      {perm?.roles?.includes(role) ? (
                        <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100">
                          <Icon name="Check" size={11} color="#059669" strokeWidth={2.5} />
                        </span>
                      ) : (
                        <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-gray-100">
                          <Icon name="Minus" size={11} color="#9CA3AF" strokeWidth={2} />
                        </span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RolePermissionsPanel;